import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { theme } from '../theme/theme'
import { BodySmallMedium } from './styles/Typography'
import { Caret } from './icons'
import { ChatBubble } from './icons/ChatBubble'

interface Props {
  count: number
}

export const MessageNotificationBanner = ({ count }: Props) => {
  const { t } = useTranslation()

  return (
    <BannerLink to="/portal/messages">
      <IconWrapper>
        <ChatBubble size={24} color={theme.color.plumMid} />
        <Badge>{count}</Badge>
      </IconWrapper>
      <Message>{count === 1 ? t('employee.home.newMessage') : t('employee.home.newMessages')}</Message>
      <Caret size={16} color={theme.color.plumMid} />
    </BannerLink>
  )
}

const BannerLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.small}px;
  background-color: ${theme.color.plumLight};
  border: 1.5px solid ${theme.color.plumMid};
  border-radius: 12px;
  padding: ${theme.spacing.small}px ${theme.spacing.medium}px;
  text-decoration: none;
  margin-top: ${theme.spacing.mediumLarge}px;

  &:hover {
    opacity: 0.9;
  }

  @media screen and (min-width: ${theme.breakpoint.medium}px) {
    display: none;
  }
`

const IconWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Badge = styled.span`
  position: absolute;
  top: -2px;
  right: -4px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${theme.color.orange};
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.color.white};
`

const Message = styled(BodySmallMedium)`
  color: ${theme.color.plumMid};
  margin: 0;
  flex: 1;
`
